import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import SVG from 'react-inlinesvg';

class NavBar extends React.Component {
    render(){
        return (
            <Flex column center width='100%'>
                <Flex className={style.Title} vAlignContent='bottom' color='black'>
                    {this.props.imgSrc &&(
                    <Flex marginRight='5px' height='40px'>
                    <SVG cacheGetRequests={true} style={{fill: this.props.fill, width: '37px', height: '37px'}} src={this.props.imgSrc}/>
                    </Flex>
                    )}
                    <Flex height='40px' vAlignContent='center'>
                    {this.props.title}
                    </Flex>
                </Flex>
                <Flex className={style.Body} color='black'>
                    {this.props.subTitle}
                </Flex>
            </Flex>
        )

    }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/Standard/index.js